var utils = require('../utils');

module.exports = {
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    utils.redirectTo(credential, charge.channel);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pingpp-js/src/channels/paypal.js
// module id = ZvHn
// module chunks = 5